export type AppErrorCode = 'AUTH' | 'FORBIDDEN' | 'CONFLICT' | 'INVALID' | 'UNAVAILABLE'
export type AppError = { code: AppErrorCode; message: string }

export function mapProviderError(error: { message: string; code?: string | null } | null): AppError | null {
  if (!error) return null
  const message = error.message.toLocaleLowerCase('en')

  if (message.includes('invalid login credentials')) {
    return { code: 'AUTH', message: 'Email hoặc mật khẩu không hợp lệ.' }
  }
  if (message.includes('email not confirmed')) {
    return { code: 'AUTH', message: 'Email chưa được xác nhận.' }
  }
  if (message.includes('permission') || message.includes('row-level security') || message.includes('not authorized') || message.includes('denied')) {
    return { code: 'FORBIDDEN', message: 'Bạn không có quyền thực hiện thao tác này.' }
  }
  if (message.includes('duplicate') || error.code === '23505') {
    return { code: 'CONFLICT', message: 'Dữ liệu đã tồn tại hoặc đang xung đột với trạng thái hiện tại.' }
  }
  if (message.includes('invalid') || message.includes('required')) {
    return { code: 'INVALID', message: 'Dữ liệu không hợp lệ hoặc thiếu thông tin bắt buộc.' }
  }
  return { code: 'UNAVAILABLE', message: 'Không thể hoàn tất yêu cầu. Vui lòng thử lại.' }
}
